if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"_vk_cloud_lk_host","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(400|418|608|964)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}